import { render, staticRenderFns } from "./ReviewsLanding.vue?vue&type=template&id=285f8a2e&"
import script from "./ReviewsLanding.vue?vue&type=script&lang=js&"
export * from "./ReviewsLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports